import { ComplaintBook } from "../Model/ComplaintBook";
import ComplaintBookRepository from "../Repository/ComplaintBookRepository";


export interface GetComplaintBookByIdUseCase {
  invoke: (id: number) => Promise<ComplaintBook | null>;
}

export class GetComplaintBookById implements GetComplaintBookByIdUseCase {
    private Repo: ComplaintBookRepository;
    constructor(_Repo: ComplaintBookRepository) {
        this.Repo = _Repo;
    }

    async invoke(id: number) {
        if(!id){
            throw new Error(
                "Your todo should have at leat 2 characters."
            );
        }
        const getData = await this.Repo.getComplaintBooksById(id);
        return getData;
    }
}